import { Box, Tooltip, useTheme } from "@mui/material";
import React from "react";
import { IngredientSourceChipColor, IngredientSourceChipInfo } from "./ingredientSource";

interface IngredientSourceChipProps {
  chip: IngredientSourceChipInfo;
}

const useChipColors = (color: IngredientSourceChipColor): { background: string; text: string } => {
  const {
    palette: {
      accents: { green, blueDark, orangeDark, violet, greyBlue },
    },
  } = useTheme();

  switch (color) {
    case "green":
      return { background: green[50], text: green[700] };
    case "amber":
      return { background: orangeDark[50], text: orangeDark[700] };
    case "blue":
      return { background: blueDark[50], text: blueDark[700] };
    case "purple":
      return { background: violet[50], text: violet[700] };
    case "grey":
    default:
      return { background: greyBlue[100], text: greyBlue[700] };
  }
};

export const IngredientSourceChip = ({ chip }: IngredientSourceChipProps) => {
  const { background, text } = useChipColors(chip.color);

  const label = (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        flexShrink: 0,
        height: 16,
        px: 0.5,
        borderRadius: "4px",
        bgcolor: background,
        color: text,
        fontSize: 8,
        fontWeight: 600,
        lineHeight: 1,
        letterSpacing: "0.02em",
        whiteSpace: "nowrap",
      }}
    >
      {chip.label}
    </Box>
  );

  if (!chip.tooltip) {
    return label;
  }

  return (
    <Tooltip title={chip.tooltip}>
      {label}
    </Tooltip>
  );
};
